<div class="mb-3">
  @if (label != null) {
    <label for="{{ id }}">{{ label }}</label>
  }
  @if (showRequired) {
    <span class="required-indicator">*</span>
  }
  <input
    type="text"
    id="{{ id }}"
    class="form-control"
    [formControl]="control"
    (keypress)="onInputChange($event)"
    (paste)="onPaste($event)"
    [readonly]="isReadOnly"
    maxlength="{{ maxLength }}"
    #inputElement
    />
    @if (control.invalid) {
      <span class="help-block">
        <span class="required-indicator">
          {{ getErrorMessage() }}
        </span>
      </span>
    }
  </div>
